import React, { useCallback, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import { Button } from 'ksnm-common-ui/lib/Button';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Tree } from 'ksnm-common-ui/lib/Tree';

import { confirmDialogStore } from '@stores/confirmDialog';
import { publicationRegisterStore } from '@stores/publicationRegisterStore';

import { toTreeView } from './toTreeView';

import styles from './ReportTree.module.scss';

export const ReportTree = observer(({ onClose }: { onClose: () => void }) => {
  const { downloadReports, getExcelStream, getBlankExcel } = publicationRegisterStore;
  const { reports = [], downloadType } = downloadReports || {};

  const [checkedRows, setCheckedRows] = useState<number[]>([]);

  const treeData = useMemo(() => toTreeView(reports), [reports]);

  const onClick = useCallback(() => {
    const onDownload = () => {
      const out = reports
        .filter((item) => item.id && checkedRows.includes(item.id))
        .map((item) => ({
          organizationCode: item.organizationCode ?? '',
          reportPackageCode: item.reportPackageCode ?? '',
          reportVersionCode: item.reportVersionCode ?? '',
        }));

      if (downloadType === 'XLSX') {
        getExcelStream(out);
      } else {
        getBlankExcel(out);
      }
    };

    if (reports.length > 100) {
      confirmDialogStore.open({
        text: 'Вы пытаетесь выгрузить больше 100 файлов. Продолжить?',
        onOk: () => {
          onDownload();
        },
      });
    } else {
      onDownload();
    }

    onClose();
  }, [checkedRows, downloadType, getBlankExcel, getExcelStream, onClose, reports]);

  const onCheck = useCallback((checkedKeys, { checkedNodes }) => {
    setCheckedRows(() => checkedKeys.filter((chKey) => !checkedNodes.find((node) => node.key === chKey)?.children));
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.tree}>
        <Tree
          treeData={treeData}
          search={!!treeData.length}
          showExpandButton={false}
          selectable={false}
          virtual
          checkable
          onCheck={onCheck}
        />
      </div>

      <Button
        className={styles.button}
        icon={<Icon name="download" />}
        onClick={onClick}
        disabled={checkedRows.length === 0}
        size="large"
      >
        Скачать
      </Button>
    </div>
  );
});
